import {
    ChangeDetectionStrategy,
    Component,
    DestroyRef,
    inject,
    Input,
    OnInit,
    signal,
} from '@angular/core';

import {
    MatProgressSpinnerModule,
} from '@angular/material/progress-spinner';

import {
    SectionLoaderService,
} from 'src/app/core/services/section-loader.service';

/**
 * A spinner over a part of a screen, switched by name through `SectionLoaderService`. The element itself is the
 * loader box (see its stylesheet; the class given to it in a template, like `section-loader`, sizes it) and is hidden
 * while not enabled.
 * In AngularJS templates: `<app-section-loader loader-name="itemsCategoryLoader"></app-section-loader>`.
 */
@Component({
    standalone: true,
    imports: [
        MatProgressSpinnerModule,
    ],
    selector: 'app-section-loader',
    template: `
        @if (enabled()) {
            <div class="loader-content">
                <mat-progress-spinner [diameter]="50" mode="indeterminate"></mat-progress-spinner>
            </div>
        }
    `,
    styleUrls: ['./section-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[style.display]': "enabled() ? null : 'none'",
    },
})
export class SectionLoaderComponent implements OnInit {
    @Input('loaderName') public name = '';

    protected readonly enabled = signal(false);

    private readonly sectionLoader = inject(SectionLoaderService);
    private readonly destroyRef = inject(DestroyRef);

    public ngOnInit(): void {
        this.destroyRef.onDestroy(this.sectionLoader.register(this.name, this.enabled));
    }
}
